import { usePermission } from '../../../hooks/usePermission';
import { PERMISSIONS } from '../../../components/permission';

// Reads the raw permissions list rather than usePermission().hasPermission() — wholesale access
// is retailer-id allow-listed (see WHOLESALE_ALLOWED_RETAILER_IDS in retailer-api), not a normal
// role permission, so the all:manage superuser bypass must not grant it. Used by
// WholesaleCatalogue, WholesaleOrderNew and the sidebar nav item, none of which can rely on
// PermissionRoute/PermissionGuard for the same reason.
export function useWholesaleAccess() {
  const { userPermissions } = usePermission();

  const hasWholesaleAccess = Boolean(
    userPermissions?.permissions.includes(PERMISSIONS.WHOLESALE_PRODUCT_READ)
  );
  const isSubAccount = Boolean(userPermissions?.isSubAccount);

  // Sub-accounts without the permission aren't on the allow-list themselves, so they don't see
  // this feature — only the main account, or a sub-account explicitly granted the permission, does.
  const showWholesaleNavItem = !isSubAccount || hasWholesaleAccess;

  return { hasWholesaleAccess, isSubAccount, showWholesaleNavItem };
}

export default useWholesaleAccess;
